import RolePermissionsDialog from './RolePermissionsDialog';

export default RolePermissionsDialog;